export const serverServices = [
  "Telephelyen szerver-létesítés",
  "Telepítés, biztonsági mentés, távfelügyelet",
  "Windows, Linux szerverek menedzselése",
  "Storage-box-ok, NAS-ok létesítése",
  "Szerverek költöztetése",
  "Virtuális gépek létrehozása, kezelése"
];

export const networkServices = [
  "Vezetékes és vezeték-nélküli hálózatok",
  "Hálózati eszközök felügyelete",
  "Sérülékenység-vizsgálat",
  "Hálózati jogosultságok kezelése",
  "Tűzfalak és routerek konfigurálása",
  "VPN kialakítása, kezelése"
];

export const userSupportServices = [
  "Office szoftvercsomag telepítése",
  "Helyszíni és távoli segítségnyújtás",
  "Microsoft365 szolgáltatások",
  "Számítógépek karbantartása",
  "Vírusírtás és védelem",
  "Biztonsági mentések"
];

export const equipmentServices = [
  "Számítógépek, laptopok beszerzése",
  "Nyomtatók és kellékanyagok",
  "Hardver-elemek beszerzése",
  "Irodaszer beszerzés",
  "Nyomtatók bérlése"
];

export const securityServices = [
  "Informatikai audit",
  "Sérülékenység vizsgálat",
  "Hálózati biztonság",
  "Kódbiztonság",
  "Kamerarendszer telepítés",
  "Szoftverfejlesztés"
];

export const esetServices = [
  "ESET Endpoint Protection Standard",
  "ESET Endpoint Protection Advanced",
  "ESET Secure Business",
  "ESET Dynamic Threat Defense",
  "ESET Enterprise Inspector",
  "Hivatalos ESET támogatás",
  "Helyszíni telepítés és beállítás",
  "Rendszeres frissítések és karbantartás"
];

export const m365Services = [
  "Microsoft 365 Business Basic",
  "Microsoft 365 Business Standard",
  "Microsoft 365 Business Premium",
  "Microsoft 365 Enterprise E3/E5",
  "Exchange Online szolgáltatások",
  "SharePoint Online bevezetés",
  "Teams implementáció és oktatás",
  "Microsoft licensz menedzsment",
  "Felhő migráció támogatás",
  "Microsoft 365 biztonsági beállítások"
];

export const azureServices = [
  "Azure Virtual Machines",
  "Azure Storage megoldások",
  "Azure Active Directory",
  "Azure Backup és Site Recovery",
  "Azure Security Center",
  "Azure DevOps szolgáltatások",
  "Felhő migráció tervezés",
  "Azure költségoptimalizálás",
  "Hibrid felhő megoldások",
  "Azure monitoring és üzemeltetés"
]; 